export { default } from './ForgotPasswordPage'
